<div class="tw-flex tw-flex-row tw-gap-2 tw-h-full">
    <div class="tw-flex tw-flex-col tw-w-[50%] tw-h-full">
        @if (promotionItemsSearchForm) {
            <tilby-magic-form [form]="promotionItemsSearchForm"></tilby-magic-form>
        }
        <!-- START TABLE ADD-->
        <div class="tw-flex tw-flex-col lg:tw-pt-0 tw-overflow-auto">
            <div class="tw-flex tw-flex-col">
                <div class="tw-flex tw-flex-row tw-justify-end">
                    <button mat-button (click)="addAll()">
                        {{'PROMOTIONS.DETAILS.ADD_ALL' | translate | uppercase}}
                        <mat-icon iconPositionEnd>arrow_forward</mat-icon>
                    </button>
                </div>
            </div>
            <div class="tw-flex-1 tw-flex-col tw-overflow-auto" (scroll)="onTableAddScroll($event)">
                <table #tableAdd mat-table [dataSource]="dataSourceAdd" matSort class="table-add">
                    @for (column of columns; track column) {
                        <ng-container [matColumnDef]="column.columnDef">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{column.header}}</th>
                            <td mat-cell *matCellDef="let el">{{column.cell(el)}}</td>
                        </ng-container>
                    }

                    <!-- Action ADD -->
                    <ng-container matColumnDef="action" stickyEnd>
                        <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
                        <td mat-cell *matCellDef="let row">
                            <button mat-icon-button (click)="addRow(row)">
                                <mat-icon>arrow_forward</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumnsAdd; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsAdd;"></tr>

                    <!--tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="4">No data found</td>
                    </tr-->
                </table>
            </div>
        </div>
        <!-- END TABLE ADD-->
    </div>
    <div class="tw-flex tw-flex-col tw-w-[50%] tw-h-full">
        <!-- START TABLE REMOVE-->
        <div class="tw-flex tw-flex-col">
            <div class="tw-flex tw-flex-row">
                <button mat-button (click)="removeAll()">
                    <mat-icon>arrow_back</mat-icon>
                    {{'PROMOTIONS.DETAILS.REMOVE_ALL' | translate | uppercase}}
                </button>
            </div>
        </div>
        <div class="tw-flex tw-flex-col tw-h-full tw-overflow-auto" (scroll)="onTableRemoveScroll($event)">
            <table #tableRemove mat-table [dataSource]="dataSourceRemove" matSort class="table-remove">
                @for (column of columns; track column) {
                    <ng-container [matColumnDef]="column.columnDef">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{column.header}}</th>
                        @switch (column.columnDef) {
                            @case ('quantity') {
                                <td mat-cell *matCellDef="let el" class="mat-column-quantity">
                                    <input type="number" min="0" step="1" class="tw-flex tw-w-full tw-text-right"
                                    (ngModelChange)="column.changeCell($event, el)"
                                    [ngModel]="column.cell(el)" />
                                </td>
                            }
                            @case ('discountedPrice') {
                                @if ($promotion_type() === 'discount_perc') {
                                    <td mat-cell *matCellDef="let el" class="tw-text-green-600 tw-text-lg">
                                        {{column.cell(el)}}
                                    </td>
                                }
                                @if ($promotion_type() === 'discount_fix') {
                                    <td mat-cell *matCellDef="let el">
                                        <input type="number" min="0" step="0.01" class="tw-flex tw-w-full tw-text-right tw-text-green-600"
                                        (ngModelChange)="column.changeCell($event, el)"
                                        [ngModel]="column.cell(el)" />
                                    </td>
                                }
                            }
                            @default {
                                <td mat-cell *matCellDef="let el">
                                    {{column.cell(el)}}
                                </td>
                            }
                        }
                    </ng-container>
                }

                <!-- Action REMOVE -->
                <ng-container matColumnDef="action" stickyEnd>
                    <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
                    <td mat-cell *matCellDef="let row">
                        <button mat-icon-button (click)="removeRow(row)">
                            <mat-icon>cancel</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnsRemove; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsRemove;"></tr>

                <!--tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="4">No data found</td>
                </tr-->
            </table>
        </div>
        <!-- END TABLE REMOVE-->
    </div>
</div>
